import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useCustomer } from "@/lib/customer";
import { INPUT } from "./Connexion";

export default function ReinitialiserClient() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { setCustomer } = useCustomer();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== confirm) {
      setError("Les deux mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/customer/reset-password", { token, new_password: pw });
      setCustomer(data);
      toast.success("Mot de passe modifié — vous êtes connectée");
      navigate("/compte", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[85vh] bg-cream-light pt-32 md:pt-40 pb-20 px-6">
      <form data-testid="customer-reset-form" onSubmit={submit} className="max-w-md mx-auto bg-white rounded-3xl border border-line p-8 md:p-10 shadow-[0_20px_60px_rgba(16,114,105,0.1)]">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-mint/30 text-teal"><KeyRound size={18} /></span>
          <h1 className="font-serif text-2xl text-teal-dark">Nouveau mot de passe</h1>
        </div>
        {!token ? (
          <p data-testid="customer-reset-missing-token" className="mt-6 text-sm text-[#b04a4a]">Lien incomplet. Refaites une demande depuis la page de connexion.</p>
        ) : (
          <div className="mt-6 space-y-4">
            <label className="block text-sm font-medium text-ink">Nouveau mot de passe
              <input required type="password" autoComplete="new-password" data-testid="customer-reset-password" value={pw} onChange={(e) => setPw(e.target.value)} className={INPUT} />
            </label>
            <label className="block text-sm font-medium text-ink">Confirmer
              <input required type="password" autoComplete="new-password" data-testid="customer-reset-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={INPUT} />
            </label>
            <p className="text-xs text-ink/60">Au moins 8 caractères.</p>
            {error && <p data-testid="customer-reset-error" className="text-sm text-[#b04a4a] bg-[#b04a4a]/10 rounded-xl px-4 py-2.5">{error}</p>}
            <button type="submit" data-testid="customer-reset-submit" disabled={loading} className="w-full rounded-full bg-teal py-3.5 font-medium text-cream hover:bg-teal-dark transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading && <Loader2 size={16} className="animate-spin" />}
              Enregistrer le mot de passe
            </button>
          </div>
        )}
        <Link to="/compte/connexion" className="mt-6 inline-block text-sm text-teal link-underline">← Retour à la connexion</Link>
      </form>
    </div>
  );
}
